/**
 * Category Slider Navigation
 */
$(document).ready(function () {
    const $container = $('.category-slider-container');
    if (!$container.length) return;

    const $slider = $('.category-slider');
    const $track = $('.category-slider-track');
    const $prevBtn = $('.category-nav-prev');
    const $nextBtn = $('.category-nav-next');
    const $items = $('.category-item');

    if (!$items.length) return;

    let currentIndex = 0;
    const itemWidth = $items.first().outerWidth(true);
    const visibleItems = Math.floor($slider.width() / itemWidth);
    const maxIndex = Math.max(0, $items.length - visibleItems);

    function updateSlider() {
        const translateX = -currentIndex * itemWidth;
        $track.css('transform', `translateX(${translateX}px)`);

        $prevBtn.prop('disabled', currentIndex === 0);
        $nextBtn.prop('disabled', currentIndex >= maxIndex);
    }

    function goNext() {
        if (currentIndex < maxIndex) {
            currentIndex++;
            updateSlider();
        }
    }

    function goPrev() {
        if (currentIndex > 0) {
            currentIndex--;
            updateSlider();
        }
    }

    // Navigation buttons
    $nextBtn.on('click', goNext);
    $prevBtn.on('click', goPrev);

    // Touch/swipe support
    let startX = 0;
    let isDragging = false;

    $slider.on('touchstart mousedown', function (e) {
        startX = e.type === 'touchstart' ? e.originalEvent.touches[0].clientX : e.clientX;
        isDragging = true;
        e.preventDefault();
    });

    $(document).on('touchmove mousemove', function (e) {
        if (!isDragging) return;

        const currentX = e.type === 'touchmove' ? e.originalEvent.touches[0].clientX : e.clientX;
        const diff = startX - currentX;

        if (Math.abs(diff) > 50) {
            if (diff > 0) {
                goNext();
            } else {
                goPrev();
            }
            isDragging = false;
        }
    });

    $(document).on('touchend mouseup', function () {
        isDragging = false;
    });

    // Initial setup
    updateSlider();

    // Responsive updates
    $(window).on('resize', function () {
        const newVisibleItems = Math.floor($slider.width() / itemWidth);
        const newMaxIndex = Math.max(0, $items.length - newVisibleItems);

        if (currentIndex > newMaxIndex) {
            currentIndex = newMaxIndex;
        }

        updateSlider();
    });
}); 